import React from 'react';
import { Link } from 'react-router-dom';

const ProductCard = ({ product }) => {
  const inStock = product.stock === undefined || product.stock > 0;

  return (
    <Link
      to={`/products/${product._id}`}
      className="group bg-white border border-gray-100 rounded-xl overflow-hidden shadow-sm hover:shadow-md hover:border-blue-200 transition flex flex-col"
    >
      <div className="relative">
        {product.images && product.images.length > 0 ? (
          <img
            src={product.images[0]}
            alt={product.name}
            className="w-full h-44 object-cover group-hover:scale-105 transition duration-300"
          />
        ) : (
          <div className="w-full h-44 bg-gray-50 flex items-center justify-center">
            <span className="text-gray-300 text-xs">No image</span>
          </div>
        )}
        {product.category && (
          <span className="absolute top-2.5 left-2.5 bg-white/90 backdrop-blur-sm text-gray-600 text-[11px] font-medium px-2 py-1 rounded-full">
            {product.category}
          </span>
        )}
        {!inStock && (
          <span className="absolute top-2.5 right-2.5 bg-orange-50 text-orange-700 text-[11px] font-medium px-2 py-1 rounded-full">
            Out of stock
          </span>
        )}
      </div>

      <div className="p-4 flex flex-col flex-1">
        <h3 className="text-sm font-semibold text-gray-900 mb-1 line-clamp-1">{product.name}</h3>
        <p className="text-xs text-gray-500 mb-3 line-clamp-2 flex-1 leading-relaxed">
          {product.description}
        </p>
        
        {/* Star rating row */}
        <div className="flex items-center gap-1 mb-4">
          <div className="flex text-amber-400">
            {Array.from({ length: 5 }).map((_, i) => (
              <span key={i} className="text-xs">★</span>
            ))}
          </div>
          <span className="text-[10px] text-gray-400 font-medium">
            ({product._id ? (4.5 + (product._id.charCodeAt(0) % 5) * 0.1).toFixed(1) : '4.8'}) • {product._id ? (10 + (product._id.charCodeAt(product._id.length - 1) % 40)) : 15} reviews
          </span>
        </div>

        <div className="flex items-center justify-between mt-auto">
          <p className="text-base font-bold text-blue-600">₹{product.price}</p>
          <span className="text-xs font-medium text-blue-600 group-hover:underline">
            View details →
          </span>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;